import { createContext, useContext, useState } from "react";
import {
  getUser,
  storeUser,
  clearStorage,
  getAccessToken,
} from "utils/storage";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getUser());
  const login = (userData) => {
    storeUser(userData);
    setUser(userData);
  };

  const logout = () => {
    clearStorage();
    setUser(null);
  };

  // TODO: Add verify token api here
  const isAuthenticated = !!(getAccessToken() && user);

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
